var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('template-select',{attrs:{"data-cy":"header-template-select","currentCase":_vm.currentCase},on:{"templateChanged":_vm.templateChanged}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }